import {
  IPowerbarStoreModule,
  registerAdapter,
  unregisterAdapter,
} from '../utils';
import { IMenuSearchState } from './types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import state from './state';

const MenuSearchState: IPowerbarStoreModule<IMenuSearchState, any> = {
  name: 'MenuSearchState',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
MenuSearchState.register = registerAdapter(MenuSearchState);
MenuSearchState.unregister = unregisterAdapter(MenuSearchState);

export default MenuSearchState;
